import { render, staticRenderFns } from "./index.vue?vue&type=template&id=05a1f3c9&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ExamList: require('/Users/eralpsoftwareweb/Desktop/Active Projects/Heocademy/Gökçe Özel/gokce-ozel-nuxt/components/ExamList/index.vue').default})
